import React, { useContext, useState } from 'react'
import * as Yup from 'yup'
import { FormikErrors, useFormik } from 'formik'
import clsx from 'clsx'
import { useMutation, useQuery } from '@apollo/client'
import { CREATE_BG_ACCOUNT_BY_SALES } from '../../../graphql/mutation'
import { toast } from 'react-toastify'
import { Link, useParams } from 'react-router-dom'
import UserContext from '../../../context/UserContext'
import { Modal } from 'antd'
import UpdatePlan from '../../clientOnboard/clientOnboardingForm/ClientOnboardUpdatePlan/accountModal/UpdatePlan'

type Props = {
  nextStep: any
  formData: any
  setFormData: any
  userDetails: any
  setUserDetails: any
}

const OnboardingSchema = Yup.object().shape({
  Fullname: Yup.string()
    .min(2, 'Minimum 2 symbols')
    .max(50, 'Maximum 50 symbols')
    .matches(/^[a-zA-Z0-9().,\- ]+$/, 'Full name contains invalid characters')
    .required('Full name is required'),
  Email: Yup.string()
    .email('Wrong email format')
    .min(3, 'Minimum 3 symbols')
    .max(50, 'Maximum 50 symbols')
    .required('Email is required')
})

const ProfileDetails: React.FC<Props> = ({
  nextStep,
  formData,
  setFormData,
  userDetails,
  setUserDetails
}) => {
  const params = useParams()
  const uuid: any = params.uuid

  const [loadingOl, setLoading] = useState(false)
  const [isProfile, setIsProfile] = useState(false)
  const [createBgAccountBySales] = useMutation(CREATE_BG_ACCOUNT_BY_SALES)
  const [isUpdatePackageModalOpen, setIsUpdatePackageModalOpen] = useState<boolean>(false)
  const { currentUserRole } = useContext(UserContext)

  const isFranchiseAdmin = currentUserRole.franchiseAdmin

  const initialValues = {
    Fullname: !!userDetails ? userDetails.Fullname : '',
    Email: !!userDetails ? userDetails.Email : ''
  }

  const formik = useFormik({
    initialValues,
    enableReinitialize: true,
    validationSchema: OnboardingSchema,
    onSubmit: (values, { setSubmitting, resetForm }) => {
      console.log(values)
      setLoading(true)
      createBgAccountBySales({
        variables: {
          input: {
            franchiseId: parseInt(uuid),
            name: values.Fullname,
            email: values.Email
          }
        }
      })
        .then((res: any) => {
          if (res.data.createBgAccountBySales.status === 200) {
            setLoading(false)
            console.log(res)
            toast.success(res.data.createBgAccountBySales.message)
            const updatedFormData = {
              ...formData,
              id: res.data.createBgAccountBySales.data.id
            }
            setFormData(updatedFormData)
            packageModalOpen()
          } else {
            setLoading(false)
            toast.error(res.data.createBgAccountBySales.message)
            setSubmitting(false)
            // nextStep()
          }
        })
        .catch((err) => {
          console.log(err)
          nextStep()
        })
    }
  })
  const packageModalOpen = () => {
    setIsUpdatePackageModalOpen(true)
    setIsProfile(true)
  }

  const updatePackageHandleOk = () => {
    setIsUpdatePackageModalOpen(false)
  }

  const updatePackageCancel = () => {
    setIsUpdatePackageModalOpen(false)
  }
  if (loadingOl) {
    return <>Loading....</>
  }

  const getErrorMessage = (error: string | string[] | FormikErrors<any> | FormikErrors<any>[]) => {
    if (typeof error === 'string') {
      return error
    } else if (Array.isArray(error)) {
      return error.join(', ')
    } else {
      return JSON.stringify(error)
    }
  }
  return (
    <>
      <div id='kt_account_settings_profile_details' className='collapse show'>
        <form id='kt_account_profile_details_form' className='form' onSubmit={formik.handleSubmit}>
          {formik.status && (
            <div className='mb-lg-15 alert alert-danger'>
              <div className='alert-text font-weight-bold'>{formik.status}</div>
            </div>
          )}
          <div className='card-body border-top p-9'>
            <div className='row mb-6'>
              <h1 className=''>Profile Details</h1>
            </div>
            <div className='row mb-6'>
              <label className='col-lg-4 col-form-label required fw-semibold fs-6'>Full Name</label>

              <div className='col-lg-8 fv-row'>
                <input
                  type='text'
                  {...formik.getFieldProps('Fullname')}
                  className={clsx(
                    'form-control form-control-lg form-control-solid',
                    {
                      'is-invalid': formik.touched.Fullname && formik.errors.Fullname
                    },
                    {
                      'is-valid': formik.touched.Fullname && !formik.errors.Fullname
                    }
                  )}
                  placeholder='Full Name'
                />
                {formik.touched.Fullname && formik.errors.Fullname && (
                  <div className='fv-plugins-message-container'>
                    <div className='fv-help-block'>
                      <span role='alert'>{getErrorMessage(formik.errors.Fullname)}</span>
                    </div>
                  </div>
                )}
              </div>
            </div>
            <div className='row mb-6'>
              <label className='col-lg-4 col-form-label required fw-semibold fs-6'>
                Official Email
              </label>

              <div className='col-lg-8 fv-row'>
                <input
                  type='text'
                  {...formik.getFieldProps('Email')}
                  className={clsx(
                    'form-control form-control-lg form-control-solid',
                    {
                      'is-invalid': formik.touched.Email && formik.errors.Email
                    },
                    {
                      'is-valid': formik.touched.Email && !formik.errors.Email
                    }
                  )}
                  placeholder='Email'
                />
                {formik.touched.Email && formik.errors.Email && (
                  <div className='fv-plugins-message-container'>
                    <div className='fv-help-block'>
                      <span role='alert'>{getErrorMessage(formik.errors.Email)}</span>
                    </div>
                  </div>
                )}
              </div>
            </div>

            <div className='row mb-6 m-15'>
              <div className='col-lg-8 offset-lg-4'>
                <div className='d-flex justify-content-end'>
                  {/* "Next" button */}

                  {isFranchiseAdmin ? (
                    <Link to='/clients'>
                      <button type='button' className='btn btn-lg btn-secondary  mb-5 m-1'>
                        Cancel
                      </button>
                    </Link>
                  ) : (
                    <Link to='/franchise/all-lists'>
                      <button type='button' className='btn btn-lg btn-secondary  mb-5 m-1'>
                        Cancel
                      </button>
                    </Link>
                  )}
                  <button
                    type='submit'
                    className='btn btn-lg btn-primary  mb-5 m-1'
                    disabled={formik.isSubmitting || !formik.isValid}
                  >
                    Next
                  </button>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>

      <Modal
        title='Update Package'
        open={isUpdatePackageModalOpen}
        onOk={updatePackageHandleOk}
        onCancel={updatePackageCancel}
        footer={false}
        destroyOnClose
      >
        <UpdatePlan
          closeModal={updatePackageCancel}
          isPaymentDetails={formData}
          nextStep={nextStep}
          isProfile={isProfile}
        />
      </Modal>
    </>
  )
}

export default ProfileDetails
